import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import axios from 'axios'
import i18n from './lang'
import 'vant/lib/index.css'
import cocosUtil from './assets/js/cocosUtil.js'

axios.defaults.baseURL = process.env.VUE_APP_API
axios.interceptors.request.use(config => {
  // 增加时间戳
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }

  return config
}, error => {
  // 发送请求错误操作
  return Promise.reject(error)
})

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_AXIOS
Vue.prototype.$axios = axios
Vue.prototype.$cocosUtil = cocosUtil
console.log(document.documentElement.style.fontSize)
if (parseInt(document.documentElement.style.fontSize.replace('px', '')) > 54) {
  document.documentElement.style.fontSize = '54px'
}
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
